import { Box } from "@mui/material";

const PageContainer = ({
    children,
    maxWidth = { lg: 1400, xl: 1600 },
    disableGutters = false,
    fullHeight = true,
}) => {
    return (
        <Box
            sx={(theme) => ({
                width: "100%",
                position: "relative",

                maxWidth: {
                    xs: "100%",
                    md: "100%",
                    ...maxWidth,
                },

                mx: {
                    lg: "auto",
                },

                px: disableGutters ? 0 : { xs: 1, sm: 2, md: 3 },
                py: { xs: 1.5, md: 2.5 },

                minHeight: fullHeight
                    ? {
                        xs: "calc(100vh - 60px)",
                        md: "calc(100vh - 68px)",
                    }
                    : "auto",
                ...(fullHeight && {
                    "@supports (height: 100dvh)": {
                        minHeight: {
                            xs: "calc(100dvh - 60px)",
                            md: "calc(100dvh - 68px)",
                        },
                    },
                }),

                display: "flex",
                flexDirection: "column",
                gap: { xs: theme.spacing(1.75), md: theme.spacing(2.25) },

                "& > *": {
                    minWidth: 0,
                },
            })}
        >
            {children}
        </Box>
    );
};

export default PageContainer;
